// Central constants for consistent naming across the application

export const USER_ROLES = {
  ADMIN: 'admin',
  PARTNER: 'partner',
};

/** Default page size for tables and paginated lists across the app. */
export const LIST_ROWS_PER_PAGE = 10;

/** Number of page buttons shown in the sliding pagination window (excluding first/last). */
export const VISIBLE_PAGE_COUNT = 4;

export const USERS_LIST_ROWS_PER_PAGE = 20;
// System names and labels
export const SYSTEM_LABELS = {
  SYSTEM_MODERATION: 'System Moderation',
  UNKNOWN_REPORTER: 'Unknown Reporter',
  UNKNOWN_USER: 'Unknown User',
};

// Reporter types
export const REPORTER_TYPES = {
  SYSTEM_MODERATION: 'System_moderation',
  UNKNOWN_REPORTER: 'Unknown_reporter',
};

// Violation types
export const VIOLATION_TYPES = {
  CAPTION: 'caption',
  IMAGE: 'image',
  VIDEO: 'video',
  COMMENT: 'comment',
  MESSAGE: 'message',
};

// Violation type filter options
export const VIOLATION_TYPE_FILTERS = [
  { value: '', label: 'All' },
  { value: VIOLATION_TYPES.CAPTION, label: 'Caption' },
  { value: VIOLATION_TYPES.IMAGE, label: 'Image' },
  { value: VIOLATION_TYPES.VIDEO, label: 'Video' },
  { value: VIOLATION_TYPES.COMMENT, label: 'Comment' },
  { value: VIOLATION_TYPES.MESSAGE, label: 'Message' },
];
